import { airlineLogos } from "../data/contentSources";
import { useTheme } from "../context/ThemeContext";

const SlideClients = () => {
  const { isDark } = useTheme();

  return (
    <div className="space-y-4">
      <h2 className={`text-3xl font-bold ${isDark ? "text-white" : "text-slate-900"}`}>Trusted by Leading Airlines</h2>
      <p className={`leading-relaxed ${isDark ? "text-slate-300" : "text-slate-600"}`}>
        Aeroplay already partnered with dozens of airlines across all continents, engaging with 10s of millions of passengers per year.
      </p>
      
      {/* Client logos - 12 logos in 4x3 grid */}
      <div className="grid grid-cols-4 gap-2 mt-4 px-8">
        {airlineLogos.map((airline) => (
          <div 
            key={airline.name} 
            className={`rounded-lg border overflow-hidden ${
              isDark 
                ? "bg-slate-900 border-slate-700/50" 
                : "bg-transparent border-slate-200"
            }`} 
            style={{ aspectRatio: '16/5' }}
          >
            <img 
              src={airline.logo} 
              alt={airline.name}
              className={`w-full h-full object-contain scale-90 ${
                isDark ? "" : "invert"
              }`}
            />
          </div>
        ))}
      </div>
      
      {/* Testimonials */}
      <div className="grid grid-cols-2 gap-3 mt-4">
        <div className={`rounded-xl p-3 border-l-2 ${
          isDark 
            ? "bg-slate-800/30 border-[#FFD700]" 
            : "bg-[#FFD700]/10 border-[#FFD700]"
        }`}>
          <p className={`text-xs italic leading-relaxed ${isDark ? "text-slate-300" : "text-slate-600"}`}>"I would like to express my sincere appreciation to the Aeroplay team for their continuous efforts in evolving content curation strategies and delivering quick turnaround times."</p>
          <p className={`text-xs mt-2 ${isDark ? "text-slate-500" : "text-slate-400"}`}>- Emily S. Koshy, Head of Airlines Customer Relations, Malaysia Airlines</p>
        </div>
        <div className={`rounded-xl p-3 border-l-2 ${
          isDark 
            ? "bg-slate-800/30 border-[#FFD700]" 
            : "bg-[#FFD700]/10 border-[#FFD700]"
        }`}>
          <p className={`text-xs italic leading-relaxed ${isDark ? "text-slate-300" : "text-slate-600"}`}>"Jazeera Airways and Aeroplay have been formidable partners for 5 years now. We are grateful for their understanding of our passenger demographics and providing quality content for our IFE."</p>
          <p className={`text-xs mt-2 ${isDark ? "text-slate-500" : "text-slate-400"}`}>- Andrew Ward, VP Marketing & Customer Experience, Jazeera Airways</p>
        </div>
      </div>
    </div>
  );
};

export default SlideClients;
